import Api from "../api";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import {
    IServicesNomenclaturesRepository,
} from "@/repository/services/ServicesNomenclatureRepository.types";
import {
    IServicesNomenclaturesTree,
    ServicesNomenclaturesResponseType, ServicesNomenclaturesTreeResponseType,
} from "@/entity/servicesNomenclature/services.nomenclature.types";
import ServicesNomenclature from "@/entity/servicesNomenclature/services.nomenclature";
import {
    ServiceNomenclatureCreateRequestType,
} from "@/form/service/serviceNomenclatureCreate.types";
import {
    IServicesNomenclatures,
    IServicesNomenclaturesListItem
} from "@/entity/servicesNomenclature/services.nomenclature.types";
import ServicesNomenclaturesTree from "@/entity/servicesNomenclature/services.nomenclature.tree";
import {PositionResponseType} from "@/entity/position/position.types";
import Position from "@/entity/position/position";

export class ServicesNomenclatureRepository implements IServicesNomenclaturesRepository {
    async fetchAll(data?: FormData): Promise<IServicesNomenclatures> {
        const response = await Api.get("/service/nomenclature/get", {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        const responseData = response.data as ServicesNomenclaturesResponseType;
        return new ServicesNomenclature(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IServicesNomenclaturesListItem> {
        const response = await Api.get(`/service/nomenclature/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: "repeat"});
            },
        });
        const responseData = response.data as ServicesNomenclaturesResponseType;

        return new ServicesNomenclature(responseData).data[0];
    }

    async getTree(data?: { name: string }): Promise<IServicesNomenclaturesTree[]> {
        const response = await Api.get(`/service/nomenclature/get_tree`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: "repeat"});
            },
        });
        const responseData = response.data as ServicesNomenclaturesTreeResponseType[];
        return responseData.map((treeItem: ServicesNomenclaturesTreeResponseType) => new ServicesNomenclaturesTree(treeItem));
    }

    async create(data: ServiceNomenclatureCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service/nomenclature/create`, data);
        return response.data;
    }

    async update(data: ServiceNomenclatureCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service/nomenclature/update`, data);
        return response.data;
    }

    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/service/nomenclature/delete`, data);
        return response.data;
    }
}
